<template>
  <div class="home">
        <div class="row">
        <div class="" style="background-color:#EFEFEF;height: 280px;border-radius:15px; width:66%;display: flex;align-items: center;">
            <div class="grid-content bg-purple cost" style="position: relative;display: flex;padding-right:15px;">
                <div style="width:50%;"><div><img src="../../assets/img/org-bj.png" style="width: 100%;"/></div></div>
                <div style="width:50%;display: flex;flex-direction: column;justify-content: center;">
                    <h2 class="display" style="font-size: 22px;line-height:40px;">HI ！ Welcome</h2>
                    <p  class="display" style="line-height:40px;">
                        <span>欢迎回来！尊贵的</span>
                        <span style="font-size:14px;font-weight: bold;margin: 0px 10px;">{{orgname}}</span>
                        <span>机构,</span>
                        <span style="font-size:16px;font-weight: bold;margin: 0px 10px;">{{user_name}}</span>
                        <span>用户！</span>
                    </p>
                    <span style="line-height:20px;font-size: 13px;">
                        Scholarcy将您的文档转换为可搜索，可共享的摘要抽认卡库，可在任何设备上访问，并带有协作式笔记和注释
                    </span>
                </div>
            </div>
        </div>
       
        <div class=""  style="background-color:#EFEFEF;height: 280px;border-radius:15px; width:33%; ">
            <h2 style="margin:10px 0 0 10px ;">剩余量</h2>
            <div class="grid-content bg-purple" style="position: relative;">
                <div id="main"></div>
            </div>
        </div>
        <div class="col-12 col-m-12" style="margin-top:30px;">
                <!-- style="background-color:#EFEFEF" -->
            <h2>近30天统计使用量</h2>
            <div id="box" ref="rankMain"></div>
        </div>
        </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name:"home",
    data(){
        return{
            orgname:localStorage.getItem("organ_name"),
            user_name:localStorage.getItem("user_name"),
            date:[],
            count:[]
        }
    },
    created(){
        this.fileNumInfo() // 剩余量 已使用统计
        this.monthInfo() // 月使用量统计
    },
    mounted(){
        setTimeout(() => {
            this.boxChart();
            const resizeOb = new ResizeObserver((entries) => {
                for (const entry of entries) {
                echarts.getInstanceByDom(entry.target).resize();
                }
            });
            resizeOb.observe(this.$refs.rankMain);
            });
    },
    methods: {
        // 月统计
        monthInfo(){
            this.$http({
                url:"api/get_month",
                method:'GET',
            }).then(res=>{
                var list = res.data.data
                list.forEach(item => {
                    this.date.push(item.date)
                    this.count.push(item.count)
                });
                this.boxChart()
            })
        },
        boxChart(){
            var chartDom = document.getElementById('box');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
            xAxis: {
                type: 'category',
                data: this.date,
                axisLabel :{
                    interval:0,
                    rotate: '45' 
                },
                axisLine: { 
                lineStyle: { // X 轴颜色配置
                color: '#9250E6'  
                } 
          },
            },
            tooltip : {
                trigger: 'axis',
                axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#9250E6'
                }
            }
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                data: this.count,
                name: '使用量',
                type: 'line',
                itemStyle:{
                    normal:{
                        label:{
                            show:true,
                            position:["100%",2],
                            textStyle:{
                                fontSize:12,
                            }
                        },
                        color:'#9250E6',
                        lineStyle:{
                            color:'#9250E6'
                        }
                        
                    }
                }
                }
            ]
            };

            option && myChart.setOption(option);
        },
        fileNumInfo(){
            this.$http({
                url:"api/user_file_num/",
                method:"GET",
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params:{
                     organ_name:localStorage.getItem("organ_name")
                }
            }).then(res=>{
                this.surplus = res.data.surplus
                this.used_num = res.data.used_num
                this.initChart()
                // console.log(res)
            })
        },
        initChart(){
            var chartDom = document.getElementById('main');
            var myChart = echarts.init(chartDom);
            var option;
            var datas = [
            [
                { name: '剩余量', value: this.surplus },
                { name: '已使用', value: this.used_num }
            ]
            ];
            option = {
            title: {
                // text: '个人分配量  使用量',
                left: 'right',
                top:'0%',
                textStyle: {
                color: 'black',
                fontWeight: 'normal',
                fontSize: 20
                }
            },
            series: datas.map(function (data, idx) {
                // var top = idx * 33.3;
                return {
                type: 'pie',
                // radius: [20, 60],
                 radius: '200%',
                //   top: top + '%',
                top: '38%',
                height: '33.33%',
                left: 'center',
                width: 400,
                itemStyle: {
                    borderColor: '#fff',
                    borderWidth: 1,
                    normal:{
                        color:function(colors){
                            var colorList = [
                            '#91cd77',
                            '#0052D9',
                            ];
                            return colorList[colors.dataIndex];
                        }
                    }
                },
                label: {
                    alignTo: 'edge',
                    formatter: '{name|{b}}\n{time|{c}次}',
                    minMargin: 5,
                    edgeDistance: 50,
                    lineHeight: 15,
                    rich: {
                    name:{
                        fontSize: 16,
                        color: 'black'
                    },
                    time: {
                        fontSize: 12,
                        color: '#999'
                    }
                    }
                },
                labelLine: {
                    length: 15,
                    length2: 0,
                    maxSurfaceAngle: 80
                },
                labelLayout: function (params) {
                    const isLeft = params.labelRect.x < myChart.getWidth() / 2;
                    const points = params.labelLinePoints;
                    // Update the end point.
                    points[2][0] = isLeft
                    ? params.labelRect.x
                    : params.labelRect.x + params.labelRect.width;
                    return {
                    labelLinePoints: points
                    };
                },
                data: data
                };
            })
            };

            option && myChart.setOption(option);

        },
        
    },
}
</script>

<style lang='scss'scoped>
@media (max-width: 1250px){
    .display{
        display: none;
        font-size: 13px;
    }
}
#box{
    width: 120%;
    // padding-left: 40px;
    height: 360px;
    // margin-left: 60px;
    // padding-top: 27px;
    margin: auto;
    margin-left: -10%;
}
#main{
    margin: 0 auto;
    width: auto;
    height: 230px;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    padding: 0px;
    margin: 0px;
    border-width: 0px;
}
.home{
    background-color: white;
    padding: 20px;
}
* {
    box-sizing: border-box;
}
.row{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.row:after {
    content: "";
    clear: both;
    display: block;
}
[class*="col-"] {
    float: left;
    padding: 15px;
}
html {
    font-family: "Lucida Sans", sans-serif;
}
.header {
    background-color: #9933cc;
    color: #ffffff;
    padding: 15px;
}
.menu ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.menu li {
    padding: 8px;
    margin-bottom: 7px;
    background-color :#33b5e5;
    color: #ffffff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
.menu li:hover {
    background-color: #0099cc;
}
.aside {
    background-color: #33b5e5;
    padding: 15px;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
.footer {
    background-color: #0099cc;
    color: #ffffff;
    text-align: center;
    font-size: 12px;
    padding: 15px;
}
/* For mobile phones: */
[class*="col-"] {
    width: 100%;
}
@media only screen and (min-width: 600px) {
    /* For tablets: */
    .col-m-12 {width: 8.33%;}
    .col-m-2 {width: 16.66%;}
    .col-m-3 {width: 25%;}
    .col-m-4 {width: 33.33%;}
    .col-m-5 {width: 41.66%;}
    .col-m-6 {width: 50%;}
    .col-m-7 {width: 58.33%;}
    .col-m-8 {width: 66.66%;}
    .col-m-9 {width: 75%;}
    .col-m-10 {width: 83.33%;}
    .col-m-11 {width: 91.66%;}
    .col-m-12 {width: 100%;}
}
@media only screen and (min-width: 768px) {
    /* For desktop: */
    .col-1 {width: 8.33%;}
    .col-2 {width: 16.66%;}
    .col-3 {width: 25%;}
    .col-4 {width: 33.33%;}
    .col-5 {width: 41.66%;}
    .col-6 {width: 50%;}
    .col-7 {width: 58.33%;}
    .col-8 {width: 66.66%;}
    .col-9 {width: 75%;}
    .col-10 {width: 83.33%;}
    .col-11 {width: 91.66%;}
    .col-12 {width: 100%;}
}
</style>